/**
 * Home page yellow highlight wipes — matches oddfishmedia.com.au scroll trigger.
 * Live site: when the highlighted word enters the viewport, add .scrolled + .strike-visible.
 */
(function () {
  "use strict";

  function heroIsCovering() {
    var hero = document.querySelector(".oddfish-homepage-hero");
    if (!hero) return false;
    return !hero.classList.contains("is-hidden") && !hero.classList.contains("slide-out-top");
  }

  function initAos() {
    if (typeof AOS === "undefined" || window._oddfishHomeAosInit) return;
    AOS.init({
      once: true,
      duration: 800,
      easing: "ease-out-cubic",
      offset: 120,
      disable: false
    });
    window._oddfishHomeAosInit = true;
  }

  function refreshAos() {
    if (typeof AOS === "undefined" || !window._oddfishHomeAosInit) return;
    if (typeof AOS.refreshHard === "function") {
      AOS.refreshHard();
      return;
    }
    AOS.refresh();
  }

  function findSectionStrikes(section) {
    var strikes = section.querySelectorAll(
      ".strike, .oddfish-yellow-strike[data-strike='case'], .oddfish-yellow-strike[data-strike='testimonial']"
    );
    return strikes.length ? strikes : [];
  }

  function getPrimaryStrike(section) {
    return section.querySelector(
      "h2 .strike, h2 .oddfish-yellow-strike, .of-svc-heading .strike, .strike, .oddfish-yellow-strike[data-strike='case'], .oddfish-yellow-strike[data-strike='testimonial']"
    );
  }

  function sectionReached(section) {
    if (document.querySelector(".oddfish-homepage-hero") && heroIsCovering()) return false;

    var strike = getPrimaryStrike(section);
    if (!strike) return false;

    var rect = strike.getBoundingClientRect();
    var viewportBottom = window.innerHeight - 80;

    /* Match live oddfish-home.js — trigger when the highlighted word enters view. */
    return rect.top < viewportBottom && rect.bottom > 80;
  }

  function sectionStrikesDone(section) {
    return section.dataset.strikesRevealed === "1";
  }

  function markSectionStrikesDone(section) {
    section.dataset.strikesRevealed = "1";
  }

  function markSectionScrolled(section) {
    if (section.classList.contains("animate")) {
      section.classList.add("scrolled");
    }
  }

  function promoteAosElements(section) {
    section.querySelectorAll("[data-aos]").forEach(function (el) {
      el.classList.add("aos-animate");
    });
  }

  function applyStrikeVisible(strike) {
    strike.classList.remove("strike-visible", "oddfish-strike-visible");
    void strike.offsetWidth;
    strike.classList.add("strike-visible");
    if (strike.classList.contains("oddfish-yellow-strike")) {
      strike.classList.add("oddfish-strike-visible");
    }
  }

  function revealSectionStrikes(section) {
    if (sectionStrikesDone(section)) return;

    var strikes = findSectionStrikes(section);
    if (!strikes.length) return;

    strikes.forEach(function (strike) {
      if (strike.dataset.strikePlayed === "1") return;
      applyStrikeVisible(strike);
      strike.dataset.strikePlayed = "1";
    });

    markSectionStrikesDone(section);
  }

  function handleScrollReveal() {
    if (document.querySelector(".oddfish-homepage-hero") && heroIsCovering()) return;

    document.querySelectorAll(".animate").forEach(function (section) {
      if (sectionStrikesDone(section)) return;
      if (!sectionReached(section)) return;

      markSectionScrolled(section);
      promoteAosElements(section);
      revealSectionStrikes(section);
    });
  }

  function observeAnimateSections(root) {
    if (!window._oddfishStrikeObserver) return;
    var scope = root || document;
    scope.querySelectorAll(".animate").forEach(function (section) {
      if (section.dataset.strikeObserved === "1") return;
      section.dataset.strikeObserved = "1";
      window._oddfishStrikeObserver.observe(section);
    });
  }

  function bindIntersectionFallback() {
    if (!("IntersectionObserver" in window)) return;

    if (!window._oddfishStrikeObserver) {
      window._oddfishStrikeObserver = new IntersectionObserver(
        function (entries) {
          var hit = false;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) hit = true;
          });
          if (hit) handleScrollReveal();
        },
        { rootMargin: "0px 0px -5% 0px", threshold: [0, 0.05, 0.15, 0.35] }
      );
    }

    observeAnimateSections(document);
  }

  function bindScrollReveal() {
    if (window._oddfishStrikeScrollBound) return;
    window._oddfishStrikeScrollBound = true;

    window.addEventListener("scroll", handleScrollReveal, { passive: true });
    window.addEventListener("resize", handleScrollReveal, { passive: true });
  }

  function resetStrikes(scope) {
    var root = scope || document;
    root.querySelectorAll(
      ".strike, .oddfish-yellow-strike[data-strike='case'], .oddfish-yellow-strike[data-strike='testimonial']"
    ).forEach(function (strike) {
      strike.classList.remove("strike-visible", "oddfish-strike-visible");
      delete strike.dataset.strikePlayed;
    });
    root.querySelectorAll(".animate").forEach(function (section) {
      section.classList.remove("scrolled");
      delete section.dataset.strikeObserved;
      delete section.dataset.strikesRevealed;
    });
  }

  function bootHomeAnimations() {
    initAos();
    bindScrollReveal();
    bindIntersectionFallback();
    handleScrollReveal();

    requestAnimationFrame(handleScrollReveal);
    window.setTimeout(handleScrollReveal, 50);
    window.setTimeout(handleScrollReveal, 200);
    window.setTimeout(refreshAos, 120);
    window.setTimeout(handleScrollReveal, 500);
  }

  function setupHomePage() {
    bootHomeAnimations();

    window.addEventListener("oddfish-hero-hidden", handleScrollReveal, { passive: true });

    window.addEventListener("load", function () {
      refreshAos();
      handleScrollReveal();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupHomePage);
  } else {
    setupHomePage();
  }

  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    resetStrikes(document);
    window._oddfishStrikeScrollBound = false;
    if (window._oddfishStrikeObserver) {
      window._oddfishStrikeObserver.disconnect();
      window._oddfishStrikeObserver = null;
    }
    bootHomeAnimations();
  });

  document.addEventListener("shopify:section:load", function (e) {
    resetStrikes(e.target);
    observeAnimateSections(e.target);
    handleScrollReveal();
    refreshAos();
  });

  window.oddfishHandleScrollReveal = handleScrollReveal;
})();
